module.exports = __webpack_public_path__ + "img/N375-2-EN.0542611e.png";